const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const TICKETS_REQUEST = "TICKETS_REQUEST";
const TICKETS_ERROR = "TICKETS_ERROR";
const TICKETS_SUCCESS = "TICKETS_SUCCESS";
const TICKET_COMMENT_UPDATE = "TICKET_COMMENT_UPDATE";
const COMMENT_PUT_SUCCESS = "COMMENT_PUT_SUCCESS";
const COMMENT_UPDATE_ERROR = "COMMENT_UPDATE_ERROR";
const TICKET_FETCH = "TICKET_FETCH";
const TICKET_FETCH_SUCCESS = "TICKET_FETCH_SUCCESS";
const TICKET_FETCH_ERROR = "TICKET_FETCH_ERROR";
const TICKET_CREATE = "TICKET_CREATE";
const TICKET_CREATE_SUCCESS = "TICKET_CREATE_SUCCESS";
const TICKET_CREATE_ERROR = "TICKET_CREATE_ERROR";
const TECHNICIAN_JOB_CREATE = "TECHNICIAN_JOB_CREATE";

import Vue from "vue";

const state = { status: "", tickets: [] };

const getters = {
    getTickets: state => state.tickets.sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1)),
    getTicket: (state)=> (ticketid) => {
        return state.tickets.find(ticket => ticket.ticketid === ticketid)
      },
    isTicketsListLoaded: state => !!state.tickets,
    searchTickets: (state) => searchParam => {
        var searchTerm = new RegExp(searchParam, "i") //Tickets are searched by ID number, subject, and description contents.
        return state.tickets.filter((ticket => searchTerm.test(ticket.ticketid) || searchTerm.test(ticket.subject) || searchTerm.test(ticket.description)))
    }

};

const actions = {
    [TICKETS_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(TICKETS_REQUEST);
            commit('addLoading', {handle:'tickets',name:'Load Tickets'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
            
            fetch(Vue.prototype.$apiServer + 'tickets', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'tickets')
                        if (resp.result === 'Success') {
                            commit(TICKETS_SUCCESS, resp.payload)
                            resolve(resp)
                        } else {
                            commit(TICKETS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(TICKETS_ERROR);
                    commit('removeLoading', 'tickets')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [TICKET_FETCH]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(TICKET_FETCH);
            commit('addLoading', {handle:'fetchticket'+payload.ticketID,name:'Retrieving Ticket #' + payload.ticketID})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
            
            fetch(Vue.prototype.$apiServer + 'ticket/' + payload.ticketID, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'fetchticket'+payload.ticketID)
                        if (resp.result === 'Success') {
                            commit(TICKET_FETCH_SUCCESS, resp.payload)
                            resolve(resp)
                        } else {
                            commit(TICKET_FETCH_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(TICKET_FETCH_ERROR);
                    commit('removeLoading', 'fetchticket'+payload.ticketID)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },

    [TICKET_CREATE]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(TICKET_FETCH);
            commit('addLoading', {handle:'createticket', name:'Creating Ticket'})
            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
            
            fetch(Vue.prototype.$apiServer + 'ticket', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'createticket')
                        if (resp.result === 'Success') {
                            commit(TICKET_CREATE_SUCCESS, resp.payload)
                            resolve(resp)
                        } else {
                            commit(TICKET_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(TICKET_CREATE_ERROR);
                    commit('removeLoading', 'createticket')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },


    [TECHNICIAN_JOB_CREATE]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(TICKET_FETCH);
            commit('addLoading', {handle:'createtechnicianticket', name:'Creating Technician Job'})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'ticket/ventia', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'createtechnicianticket')
                        if (resp.result === 'Success') {
                            commit(TICKET_CREATE_SUCCESS, resp.payload)
                            resolve(resp)
                        } else {
                            commit(TICKET_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(TICKET_CREATE_ERROR);
                    commit('removeLoading', 'createtechnicianticket')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },


    [TICKET_COMMENT_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(TICKET_COMMENT_UPDATE);
            commit('addLoading', {handle:'addticketcomment'+payload.ticketID, name:'Adding Ticket Comment'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload.payload)
            };

            fetch(Vue.prototype.$apiServer + 'ticket/' + payload.ticketID+'/comment', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'addticketcomment'+payload.ticketID)
                        if (resp.result === 'Success') {
                            commit(COMMENT_PUT_SUCCESS, resp.payload)
                            resolve(resp)
                        } else {
                            commit(COMMENT_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(COMMENT_UPDATE_ERROR);
                    commit('removeLoading', 'addticketcomment'+payload.ticketID)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
};

const mutations = {
    [TICKETS_REQUEST]: state => {
        state.status = "loading";
    },
    [TICKET_COMMENT_UPDATE]: state => {
        state.updatestatus = "loading";
    },
    [TICKETS_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "tickets", resp);
    },
    [TICKET_FETCH]: (state) => {
        state.ticketfetchstatus = "loading";
    },
    [TICKET_FETCH_SUCCESS]: (state) => {
        state.ticketfetchstatus = "success";
    },
    [TICKET_FETCH_ERROR]: (state) => {
        state.ticketfetchstatus = "error";
    },
    [TICKET_CREATE]: (state) => {
        state.ticketcreatestatus = "loading";
    },
    [TICKET_CREATE_SUCCESS]: (state) => {
        state.ticketcreatestatus = "success";
    },
    [TICKET_CREATE_ERROR]: (state) => {
        state.ticketcreatestatus = "error";
    },
    [COMMENT_PUT_SUCCESS]: (state) => {
        state.updatestatus = "success";
    },
    [TICKETS_ERROR]: state => {
        state.status = "error";
    },
    [COMMENT_UPDATE_ERROR]: state => {
        state.updatestatus = "error";
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.tickets = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};